import { GetChatMembersResponse, GetInkSignOrderDocsResponse, GetOrderMessagesResponse, GetOrderResponse, GetOrdersResponse } from '~/types/backend';
import {
  GET_ORDER_LIST,
  GET_IN_PROGRESS_ORDER_LIST,
  GET_ORDER_LIST_OK,
  GET_ORDER_LIST_ERR,
  DO_ORDER_LIST_CLEANUP,
  SET_ORDER_FILTER_TOGGLE,
  SET_VIEW_MODE_TOGGLE,
  SET_NOTARY_ORDER_FILTER_TOGGLE,

  GET_ORDER,
  GET_ORDER_OK,
  GET_ORDER_ERR,
  DO_ORDER_SINGLE_CLEANUP,

  GET_ORDER_MESSAGES,
  GET_ORDER_MESSAGES_OK,
  GET_ORDER_MESSAGES_ERR,
  GET_LAST_ORDER_MESSAGE,
  GET_LAST_ORDER_MESSAGE_OK,
  GET_LAST_ORDER_MESSAGE_ERR,
  GET_CHAT_MEMBERS,
  GET_CHAT_MEMBERS_OK,
  GET_CHAT_MEMBERS_ERR,

  GET_ORDER_INK_SIGN_DOCS,
  GET_ORDER_INK_SIGN_DOCS_OK,
  GET_ORDER_INK_SIGN_DOCS_ERR,
  DO_ORDER_INK_SIGN_DOCS_CLEANUP,
  RESET_CHANNEL_UNREAD_MESSAGES,

} from "./actionTypes";
import { TListParams, TMessage } from '~/types/global';

/********** LIST **********/

export const getOrderList = (params: TListParams, silentLoad: boolean = false) => ({
  type: GET_ORDER_LIST,
  payload: { params, silentLoad },
});

export const getInProgressOrderList = () => ({
  type: GET_IN_PROGRESS_ORDER_LIST,
});

export const getOrderListOk = (response: GetOrdersResponse) => ({
  type: GET_ORDER_LIST_OK,
  payload: { response },
});

export const getOrderListErr = (error: Error) => ({
  type: GET_ORDER_LIST_ERR,
  payload: { error },
});

export const doOrderListCleanup = () => ({
  type: DO_ORDER_LIST_CLEANUP,
});

export const setOrderFilterToggle = (status: number) => ({
  type: SET_ORDER_FILTER_TOGGLE,
  payload: { status },
});

export const setViewModeToggle = (mode: string) => ({
  type: SET_VIEW_MODE_TOGGLE,
  payload: { mode },
});

export const setNotaryOrderFilterToggle = (status: number) => ({
  type: SET_NOTARY_ORDER_FILTER_TOGGLE,
  payload: { status },
});

/********** SINGLE **********/

export const getOrder = (id: number) => ({
  type: GET_ORDER,
  payload: { id },
});

export const getOrderOk = (response: GetOrderResponse) => ({
  type: GET_ORDER_OK,
  payload: { response },
});

export const getOrderErr = (error: Error) => ({
  type: GET_ORDER_ERR,
  payload: { error },
});

export const doOrderSingleCleanup = () => ({
  type: DO_ORDER_SINGLE_CLEANUP,
});

/********** MESSAGES **********/

export const getOrderMessages = (orderId: number, channelId: number | any, params?: TListParams) => ({
  type: GET_ORDER_MESSAGES,
  payload: { orderId, channelId, params }
});

export const getOrderMessagesOk = (response: GetOrderMessagesResponse, channelId: number) => ({
  type: GET_ORDER_MESSAGES_OK,
  payload: { response, channelId }
});

export const getOrderMessagesErr = (error: Error) => ({
  type: GET_ORDER_MESSAGES_ERR,
  payload: { error }
});

export const getLastOrderMessage = (orderId: number) => ({
  type: GET_LAST_ORDER_MESSAGE,
  payload: { orderId },
});

export const getLastOrderMessageOk = (response: TMessage) => ({
  type: GET_LAST_ORDER_MESSAGE_OK,
  payload: { response },
});

export const getLastOrderMessageErr = (error: Error) => ({
  type: GET_LAST_ORDER_MESSAGE_ERR,
  payload: { error },
});

export const getChatMembers = (orderId: number, channelId: number) => ({
  type: GET_CHAT_MEMBERS,
  payload: { orderId, channelId }
});

export const getChatMembersOk = (response: GetChatMembersResponse, channelId: number) => ({
  type: GET_CHAT_MEMBERS_OK,
  payload: { response, channelId }
});

export const getChatMembersErr = (error: Error) => ({
  type: GET_CHAT_MEMBERS_ERR,
  payload: { error }
});

export const resetChannelUnreadMessages = (channelId: number) => ({
  type: RESET_CHANNEL_UNREAD_MESSAGES,
  payload: { channelId }
});

/********** INK-SIGN DOCS **************/

export const getOrderInkSignDocs = (id: number) => ({
  type: GET_ORDER_INK_SIGN_DOCS,
  payload: { id },
});

export const getOrderInkSignDocsOk = (response: GetInkSignOrderDocsResponse) => ({
  type: GET_ORDER_INK_SIGN_DOCS_OK,
  payload: { response },
});

export const getOrderInkSignDocsErr = (error: Error) => ({
  type: GET_ORDER_INK_SIGN_DOCS_ERR,
  payload: { error },
});

export const doOrderInkSignDocsCleanup = () => ({
  type: DO_ORDER_INK_SIGN_DOCS_CLEANUP,
});
